// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-5f2e6d94]{align-items:center;border:2px solid #265ef5;border-radius:3px;color:rgba(0,0,0,.87);display:flex;font-size:16px;font-weight:700;height:42px;justify-content:center;letter-spacing:0;margin-bottom:8px;margin-right:8px;text-align:center;text-decoration:none;transition:0s;width:42px}.link[data-v-5f2e6d94]:hover{background:#265ef5;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
